import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const ITEM_INITIAL = { opacity: 0, x: -20 };
const ITEM_ANIMATE = { opacity: 1, x: 0 };
const ITEM_EXIT = { opacity: 0, x: 20 };
const ITEM_TRANSITION = { duration: 0.3 };
const REMOVE_HOVER = { scale: 1.1 };
const REMOVE_TAP = { scale: 0.9 };

export const CartItem = ({ item, index, onRemove, removeText }) => (
  <motion.div
    key={item.id}
    layout
    initial={ITEM_INITIAL}
    animate={ITEM_ANIMATE}
    exit={ITEM_EXIT}
    transition={ITEM_TRANSITION}
    className="rounded-2xl border border-border bg-muted/50 p-4 flex items-start justify-between gap-3"
    data-testid={`cart-item-${index}`}
  >
    <div className="flex-1">
      <div className="font-bold">{item.name}</div>
      <div className="text-sm text-primary font-semibold mt-1">{item.price}</div>
      {item.category && (
        <div className="text-xs text-muted-foreground mt-1">{item.category}</div>
      )}
    </div>
    <motion.div whileHover={REMOVE_HOVER} whileTap={REMOVE_TAP}>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => onRemove(item.id)}
        className="rounded-full h-8 w-8 flex-shrink-0"
        data-testid={`remove-item-${index}`}
      >
        <X className="h-4 w-4" />
        <span className="sr-only">{removeText}</span>
      </Button>
    </motion.div>
  </motion.div>
);
